import { useRouter } from 'next/router';
import { fetchDataApiV2, isItUndefined } from '../../util/DataUtil';
import { useState, useEffect } from 'react';
import FieldLinkButton from '../base/field-link-button';

export default function TemplateDownload({ data, alias, lang }) {
  const { asPath } = useRouter();
  const [isScrolling, setIsScrolling] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isScrolled50, setIsScrolled50] = useState(false);

  alias = asPath.substring(1);

  const getFile = () => {
    return isItUndefined(data?.field_marketo_file_url)
      ? isItUndefined(data?.field_marketo_file_url)
      : isItUndefined(data?.field_download_button_file);
  };

  useEffect(() => {
    let scrollTimeout;

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const scrollPercentage =
        (scrollPosition / (documentHeight - windowHeight)) * 100;

      setIsScrolled50(scrollPercentage >= 50);

      setIsScrolling(true);
      setIsVisible(false);
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
        setIsVisible(true);
      }, 300);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(scrollTimeout);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const buttonClass = isScrolled50
    ? `btn-active`
    : isScrolling
      ? `btn-inactive`
      : `btn-active`;

  let animatedClass = 'template-download-container animated-btn ' + buttonClass;

  if (isScrolled50) {
    animatedClass += ' go-back';
  }

  const isDisabled = data?.field_download_button_disabled?.[0]?.value === '1';

  const handleDownloadClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    downloadFile(getFile(), alias, lang);
  };

  return (
    <div className={animatedClass}>
      {data?.field_download_button_text?.[0]?.value && (
        <div
          onClickCapture={handleDownloadClick}
          className={isDisabled ? 'a-download-button-block-btn' : 'active'}
        >
          <FieldLinkButton
            link={{
              title: data?.field_download_button_text?.[0]?.value,
              uri: getFile(),
            }}
            blockTypeClass="download-button-block"
          />
        </div>
      )}
    </div>
  );
}

async function downloadFile(filePath, alias, lang) {
  var link = document.createElement('a');
  link.href = filePath;
  link.download = filePath.split('/').pop();

  filePath.startsWith('/')
    ? (window.location.href = link.href)
    : window.open(link.href, '_blank').focus();
}
